import $ from "jquery";
import Swal from "sweetalert2";

/**
 * Funções da página do carrinho
 * Só executa se a página .cart-page existir
 */
export function initCartPage() {
  // Verifica se estamos na página do carrinho
  if (!$(".cart-page").length) {
    return;
  }

  const ajaxUrl = window.ajaxurl || "/wp-admin/admin-ajax.php";

  // Função para remover item do carrinho
  function removeCartItem(cartItemKey, $cartItem) {
    $.ajax({
      type: "POST",
      url: ajaxUrl,
      data: {
        action: "update_cart_drawer",
        cart_item_key: cartItemKey,
        quantity: 0,
      },
      success: function (response) {
        if (response.success) {
          $cartItem.fadeOut(300, function () {
            $(this).remove();

            updateCartTotals(response.data);

            if (response.data.cart_is_empty) {
              location.reload();
            }

            updateCartDrawer(cartItemKey, response.data);
            $(document.body).trigger("wc_fragment_refresh");
          });
        }
      },
      error: function (xhr, status, error) {
        console.error("Erro ao remover item:", error);
        if (typeof Swal !== "undefined") {
          Swal.fire({
            title: "Erro!",
            text: "Erro ao remover item. Tente novamente.",
            icon: "error",
            confirmButtonColor: "#4f1a46",
            confirmButtonText: "OK",
            customClass: {
              popup: "rounded-2xl",
              confirmButton: "rounded-lg px-6 py-3",
            },
          });
        }
      },
    });
  }

  // Atualizar totais na página
  // Atualizar cart-drawer
  function updateCartDrawer(cartItemKey, data) {
    if (data.subtotal) {
      $("#cartSubtotalPrice").html(data.subtotal);
    }

    if (data.total) {
      $("#cartTotalPrice").html(data.total);
    }

    if (data.discount) {
      $("#cartDiscountPrice").html("- " + data.discount);
      $("#cartDiscountContainer").removeClass("hidden");
    } else {
      $("#cartDiscountContainer").addClass("hidden");
    }

    const $drawerItem = $("#cart-drawer").find(
      '[data-cart-item-key="' + cartItemKey + '"]'
    );
    if ($drawerItem.length > 0) {
      $drawerItem.fadeOut(300, function () {
        $(this).remove();
      });
    }
  }

  // Remover item (botão X)
  $(document).on("click", ".cart-page .remove-cart-item", function (e) {
    e.preventDefault();
    const $button = $(this);
    const cartItemKey = $button.data("cart-item-key");
    const $cartItem = $button.closest(".cart-item");

    if (typeof Swal !== "undefined") {
      Swal.fire({
        title: "Remover item?",
        text: "Deseja remover este item do carrinho?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#4f1a46",
        cancelButtonColor: "#6b7280",
        confirmButtonText: "Sim, remover",
        cancelButtonText: "Cancelar",
        customClass: {
          popup: "rounded-2xl",
          confirmButton: "rounded-lg px-6 py-3",
          cancelButton: "rounded-lg px-6 py-3",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          removeCartItem(cartItemKey, $cartItem);
        }
      });
    } else if (confirm("Deseja remover este item do carrinho?")) {
      removeCartItem(cartItemKey, $cartItem);
    }
  });

  // Diminuir quantidade
  $(document).on("click", ".cart-page .qty-decrease", function (e) {
    e.preventDefault();
    const $button = $(this);
    const $input = $button.siblings(".qty-input");
    const currentVal = parseInt($input.val());
    const minVal = parseInt($input.attr("min")) || 1;
    const cartItemKey = $button.data("cart-item-key");

    if (currentVal > minVal) {
      const newVal = currentVal - 1;
      updateCartQuantity(cartItemKey, newVal, $input);
    } else if (currentVal === minVal) {
      const $cartItem = $button.closest(".cart-item");

      if (typeof Swal !== "undefined") {
        Swal.fire({
          title: "Remover item?",
          text: "Deseja remover este item do carrinho?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#4f1a46",
          cancelButtonColor: "#6b7280",
          confirmButtonText: "Sim, remover",
          cancelButtonText: "Cancelar",
          customClass: {
            popup: "rounded-2xl",
            confirmButton: "rounded-lg px-6 py-3",
            cancelButton: "rounded-lg px-6 py-3",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            removeCartItem(cartItemKey, $cartItem);
          }
        });
      } else if (confirm("Deseja remover este item do carrinho?")) {
        removeCartItem(cartItemKey, $cartItem);
      }
    }
  });

  // Aumentar quantidade
  $(document).on("click", ".cart-page .qty-increase", function (e) {
    e.preventDefault();
    const $button = $(this);
    const $input = $button.siblings(".qty-input");
    const currentVal = parseInt($input.val());
    let maxVal = parseInt($input.attr("max"));
    // Se max é -1 ou inválido, considera ilimitado (9999)
    if (!maxVal || maxVal <= 0) {
      maxVal = 9999;
    }
    const cartItemKey = $button.data("cart-item-key");

    if (currentVal < maxVal) {
      const newVal = currentVal + 1;
      updateCartQuantity(cartItemKey, newVal, $input);
    }
  });

  // Atualizar quantidade
  function updateCartQuantity(cartItemKey, quantity, $input) {
    $.ajax({
      type: "POST",
      url: ajaxUrl,
      data: {
        action: "update_cart_drawer",
        cart_item_key: cartItemKey,
        quantity: quantity,
      },
      success: function (response) {
        if (response.success) {
          $input.val(quantity);
          updateCartTotals(response.data);

          if (response.data.subtotal) {
            $("#cartSubtotalPrice").html(response.data.subtotal);
          }

          if (response.data.total) {
            $("#cartTotalPrice").html(response.data.total);
          }

          if (response.data.discount) {
            $("#cartDiscountPrice").html("- " + response.data.discount);
            $("#cartDiscountContainer").removeClass("hidden");
          } else {
            $("#cartDiscountContainer").addClass("hidden");
          }

          const $drawerItem = $("#cart-drawer").find(
            '[data-cart-item-key="' + cartItemKey + '"]'
          );
          if ($drawerItem.length > 0) {
            $drawerItem.find(".cart-item-qty").val(quantity);
          }

          $(document.body).trigger("wc_fragment_refresh");
        }
      },
      error: function (xhr, status, error) {
        console.error("Erro ao atualizar quantidade:", error);
        if (typeof Swal !== "undefined") {
          Swal.fire({
            title: "Erro!",
            text: "Erro ao atualizar quantidade. Tente novamente.",
            icon: "error",
            confirmButtonColor: "#4f1a46",
            confirmButtonText: "OK",
            customClass: {
              popup: "rounded-2xl",
              confirmButton: "rounded-lg px-6 py-3",
            },
          });
        }
      },
    });
  }

  // Aplicar máscara de CEP
  $(".cart-page #calc_shipping_postcode").mask("00000-000");

  // Verifica se já existe CEP na sessão e carrega os métodos
  const hasShipping = $(".cart-page .cart-shipping-row").length > 0;
  if (hasShipping) {
    // Busca o CEP da sessão e recarrega os métodos
    $.ajax({
      type: "POST",
      url: ajaxUrl,
      data: {
        action: "get_current_shipping_info",
      },
      success: function (response) {
        if (response.success && response.data.postcode) {
          // Preenche o campo de CEP
          $("#calc_shipping_postcode").val(response.data.postcode);

          // Se houver métodos disponíveis, exibe
          if (response.data.methods && response.data.methods.length > 0) {
            displayShippingMethods(response.data.methods, response.data.selected_method);
            $("#shipping-options").removeClass("hidden");
          }
        }
      },
    });
  }

  // Calcular frete
  $(".cart-page #shipping-calculator").on("submit", function (e) {
    e.preventDefault();
    const postcode = $("#calc_shipping_postcode").val().trim();

    if (!postcode) {
      Swal.fire({
        title: "Atenção!",
        text: "Por favor, digite um CEP",
        icon: "warning",
        confirmButtonColor: "#4f1a46",
        confirmButtonText: "OK",
        customClass: {
          popup: "rounded-2xl",
          confirmButton: "rounded-lg px-6 py-3",
        },
      });
      return;
    }

    // Mostra loading
    const $button = $(this).find('button[type="submit"]');
    const originalText = $button.text();
    $button.prop("disabled", true).text("Calculando...");

    // Chamada AJAX para calcular frete
    $.ajax({
      type: "POST",
      url: ajaxUrl,
      data: {
        action: "calculate_shipping_cart",
        postcode: postcode,
      },
      success: function (response) {
        if (response.success && response.data.methods) {
          displayShippingMethods(response.data.methods, response.data.selected_method);
          $("#shipping-options").removeClass("hidden");
        } else {
          Swal.fire({
            title: "Ops!",
            text:
              response.data?.message ||
              "Não há métodos de envio disponíveis para este CEP.",
            icon: "info",
            confirmButtonColor: "#4f1a46",
            confirmButtonText: "OK",
            customClass: {
              popup: "rounded-2xl",
              confirmButton: "rounded-lg px-6 py-3",
            },
          });
          $("#shipping-options").addClass("hidden");
          resetShipping();
        }
      },
      error: function (xhr, status, error) {
        console.error("Erro ao calcular frete:", error);
        Swal.fire({
          title: "Erro!",
          text: "Erro ao calcular frete. Tente novamente.",
          icon: "error",
          confirmButtonColor: "#4f1a46",
          confirmButtonText: "OK",
          customClass: {
            popup: "rounded-2xl",
            confirmButton: "rounded-lg px-6 py-3",
          },
        });
        $("#shipping-options").addClass("hidden");
        resetShipping();
      },
      complete: function () {
        $button.prop("disabled", false).text(originalText);
      },
    });
  });

  // Renderizar métodos de envio
  function displayShippingMethods(methods, defaultId) {
    const resolvedDefault = defaultId || (methods.length > 0 ? methods[0].id : null);
    let html = "";

    methods.forEach((method) => {
      const isSelected = method.id === resolvedDefault;
      html += `
        <label class="flex items-center justify-between p-3 border border-gray-300 rounded-lg cursor-pointer hover:border-[#4f1a46] transition-colors ${
          isSelected ? "border-[#4f1a46] bg-purple-50" : ""
        }">
          <div class="flex items-center gap-3">
            <input type="radio"
                   name="shipping_method"
                   value="${method.id}"
                   class="text-[#4f1a46] focus:ring-[#4f1a46] shipping-method-radio"
                   ${isSelected ? "checked" : ""}>
            <div>
              <p class="font-medium text-gray-800">${method.label}</p>
            </div>
          </div>
          <span class="font-semibold text-gray-800">${method.cost_formatted}</span>
        </label>
      `;
    });

    $("#shipping-methods-list").html(html);

    if (resolvedDefault) {
      applyShippingMethod(resolvedDefault);
    }
  }

  // Aplicar método de envio selecionado
  $(document).on("change", ".cart-page .shipping-method-radio", function () {
    const methodId = $(this).val();
    const $label = $(this).closest("label");

    // Visual feedback
    $(".cart-page label").removeClass("border-[#4f1a46] bg-purple-50");
    $label.addClass("border-[#4f1a46] bg-purple-50");

    applyShippingMethod(methodId);
  });

  // Função para aplicar o método de envio
  function applyShippingMethod(methodId) {
    $.ajax({
      type: "POST",
      url: ajaxUrl,
      data: {
        action: "apply_shipping_method",
        method_id: methodId,
      },
      success: function (response) {
        if (response.success) {
          if (response.data.subtotal) {
            $(".cart-page .cart-subtotal-value").html(response.data.subtotal);
          }

          let $shippingRow = $(".cart-page .cart-shipping-row");
          if ($shippingRow.length === 0) {
            $(".cart-page .cart-subtotal-value").closest(".flex").after(`
                <div class="cart-shipping-row flex items-center justify-between mb-3 pb-3 border-b border-gray-200">
                  <span class="text-gray-600">Frete</span>
                  <span class="font-semibold text-gray-800 cart-shipping-value">${response.data.shipping_total_formatted}</span>
                </div>
              `);
          } else {
            $shippingRow
              .find(".cart-shipping-value")
              .html(response.data.shipping_total_formatted);
          }

          // Atualiza total
          if (response.data.total) {
            $(".cart-page #cart-total").html(response.data.total);
          }

          // Atualiza cart-drawer
          if (response.data.subtotal) {
            $("#cartSubtotalPrice").html(response.data.subtotal);
          }
          if (response.data.total) {
            $("#cartTotalPrice").html(response.data.total);
          }
        }
      },
      error: function (xhr, status, error) {
        console.error("Erro ao aplicar frete:", error);
      },
    });
  }

  // Função para resetar o frete quando não há métodos disponíveis
  function resetShipping() {
    $.ajax({
      type: "POST",
      url: ajaxUrl,
      data: {
        action: "reset_shipping_cart",
      },
      success: function (response) {
        if (response.success) {
          // Remove linha de frete
          $(".cart-page .cart-shipping-row").remove();

          // Atualiza total (sem frete)
          if (response.data.total) {
            $(".cart-page #cart-total").html(response.data.total);
          }

          // Atualiza cart-drawer
          if (response.data.total) {
            $("#cartTotalPrice").html(response.data.total);
          }

          // Limpa lista de métodos
          $("#shipping-methods-list").html("");
        }
      },
      error: function (xhr, status, error) {
        console.error("Erro ao resetar frete:", error);
      },
    });
  }

  // Aplicar cupom
  $(".cart-page #coupon-form").on("submit", function (e) {
    e.preventDefault();
    const couponCode = $("#coupon_code").val().trim().toUpperCase();

    if (!couponCode) {
      showCouponMessage("Por favor, digite um código de cupom", "error");
      return;
    }

    // Mostra loading
    const $button = $(this).find('button[type="submit"]');
    const originalText = $button.text();
    $button.prop("disabled", true).text("Aplicando...");

    $.ajax({
      type: "POST",
      url: ajaxUrl,
      data: {
        action: "apply_coupon_cart",
        coupon_code: couponCode,
      },
      success: function (response) {
        $button.prop("disabled", false).text(originalText);

        if (response.success) {
          showCouponMessage(response.data.message, "success");
          updateCartTotals(response.data);

          // Mostra cupom aplicado
          $("#applied-coupon-code").text(couponCode);
          $("#applied-coupon").removeClass("hidden");
          $("#coupon_code").val("");
          $("#coupon-form").addClass("hidden");
        } else {
          showCouponMessage(response.data.message, "error");
        }
      },
      error: function (xhr, status, error) {
        console.error("Erro ao aplicar cupom:", error);
        $button.prop("disabled", false).text(originalText);
        showCouponMessage("Erro ao aplicar cupom. Tente novamente.", "error");
      },
    });
  });

  // Remover cupom
  $(document).on("click", ".cart-page #remove-coupon", function (e) {
    e.preventDefault();

    $.ajax({
      type: "POST",
      url: ajaxUrl,
      data: {
        action: "remove_coupon_cart",
      },
      success: function (response) {
        if (response.success) {
          showCouponMessage(response.data.message, "success");
          updateCartTotals(response.data);

          // Esconde cupom aplicado
          $("#applied-coupon").addClass("hidden");
          $("#coupon-form").removeClass("hidden");

          // Remove linha de desconto
          $(".cart-page .cart-discount-row").remove();
        }
      },
      error: function (xhr, status, error) {
        console.error("Erro ao remover cupom:", error);
        showCouponMessage("Erro ao remover cupom. Tente novamente.", "error");
      },
    });
  });

  // Função para mostrar mensagem de cupom
  function showCouponMessage(message, type) {
    const $messageDiv = $("#coupon-message");
    const bgColor =
      type === "success"
        ? "bg-green-50 border-green-200 text-green-800"
        : "bg-red-50 border-red-200 text-red-800";

    $messageDiv
      .html(
        `
      <div class="p-3 ${bgColor} border rounded-lg text-sm">
        ${message}
      </div>
    `
      )
      .removeClass("hidden");

    // Esconde a mensagem após 5 segundos
    setTimeout(() => {
      $messageDiv.addClass("hidden");
    }, 5000);
  }

  // Função para atualizar totais do carrinho
  function updateCartTotals(data) {
    // Re-renderiza a lista APENAS se os IDs disponíveis mudaram em relação
    // ao DOM. Re-renderizar com a mesma lista resetaria a seleção do usuário.
    if (Array.isArray(data.shipping_methods) && data.shipping_methods.length > 0) {
      const currentIds = $('.cart-page input[name="shipping_method"]')
        .map(function () { return this.value; })
        .get()
        .filter(Boolean)
        .sort()
        .join(",");
      const newIds = data.shipping_methods.map((m) => m.id).sort().join(",");

      if (currentIds !== newIds) {
        const previousSelected = $('.cart-page input[name="shipping_method"]:checked').val();
        const stillAvailable = data.shipping_methods.some(
          (m) => m.id === previousSelected,
        );
        displayShippingMethods(data.shipping_methods);
        $("#shipping-options").removeClass("hidden");
        if (previousSelected && stillAvailable) {
          $(`input[name="shipping_method"][value="${previousSelected}"]`).prop(
            "checked",
            true,
          );
        }
      }
    } else if (
      Array.isArray(data.shipping_methods) &&
      data.shipping_methods.length === 0
    ) {
      $("#shipping-options").addClass("hidden");
      $("#shipping-methods-list").empty();
    }

    // Atualiza subtotal
    if (data.subtotal) {
      $(".cart-page .cart-subtotal-value").html(data.subtotal);
    }

    // Atualiza ou adiciona linha de desconto
    if (data.discount && parseFloat(data.discount_amount) > 0) {
      let $discountRow = $(".cart-page .cart-discount-row");
      if ($discountRow.length === 0) {
        $(".cart-page .cart-subtotal-value").closest(".flex").after(`
            <div class="cart-discount-row flex items-center justify-between mb-3 pb-3 border-b border-gray-200">
              <span class="text-green-600">Desconto</span>
              <span class="font-semibold text-green-600 cart-discount-value">-${data.discount}</span>
            </div>
          `);
      } else {
        $discountRow.find(".cart-discount-value").html(`-${data.discount}`);
      }
    } else {
      $(".cart-page .cart-discount-row").remove();
    }

    // Atualiza frete se existir
    if (data.shipping_total_formatted) {
      let $shippingRow = $(".cart-page .cart-shipping-row");
      if ($shippingRow.length > 0) {
        $shippingRow
          .find(".cart-shipping-value")
          .html(data.shipping_total_formatted);
      }
    }

    // Atualiza total
    if (data.total) {
      $(".cart-page #cart-total").html(data.total);
    }

    // Atualiza cart-drawer
    if (data.subtotal) {
      $("#cartSubtotalPrice").html(data.subtotal);
    }
    if (data.total) {
      $("#cartTotalPrice").html(data.total);
    }
  }

  // ======= PRODUTOS RELACIONADOS "Compre também" =======

  // Aumentar quantidade do produto relacionado
  $(document).on("click", ".cart-page .related-qty-increase", function (e) {
    e.preventDefault();
    const $item = $(this).closest(".related-product-item");
    const $input = $item.find(".related-qty-input");
    const currentQty = parseInt($input.val());
    const maxQty = parseInt($input.attr("max"));

    if (currentQty < maxQty) {
      $input.val(currentQty + 1);
    }
  });

  // Diminuir quantidade do produto relacionado (mínimo 1)
  $(document).on("click", ".cart-page .related-qty-decrease", function (e) {
    e.preventDefault();
    const $item = $(this).closest(".related-product-item");
    const $input = $item.find(".related-qty-input");
    const currentQty = parseInt($input.val());

    if (currentQty > 1) {
      $input.val(currentQty - 1);
    }
  });

  // Adicionar produto relacionado ao carrinho
  $(document).on("click", ".cart-page .add-related-product", function (e) {
    e.preventDefault();

    const $button = $(this);
    const $item = $button.closest(".related-product-item");
    const productId = $item.data("product-id");
    const quantity = parseInt($item.find(".related-qty-input").val());

    // Desabilita o botão e mostra loading
    $button.prop("disabled", true).text("Adicionando...");

    $.ajax({
      type: "POST",
      url: ajaxUrl,
      data: {
        action: "add_related_to_cart",
        product_id: productId,
        quantity: quantity,
      },
      success: function (response) {
        if (response.success) {
          // Animação de sucesso no botão
          $button
            .removeClass("bg-[#4f1a46] hover:bg-[#6b2558]")
            .addClass("bg-green-600")
            .text("Adicionado");

          // Adiciona animação de scale
          $button.css("transform", "scale(1.05)");
          setTimeout(() => {
            $button.css("transform", "scale(1)");
          }, 200);

          // Atualiza cart drawer
          if (response.data.cart_count) {
            $("#cart-count").text(response.data.cart_count);
          }
          if (response.data.subtotal) {
            $("#cartSubtotalPrice").html(response.data.subtotal);
          }
          if (response.data.total) {
            $("#cartTotalPrice").html(response.data.total);
          }

          // Atualiza totais da página
          if (response.data.subtotal) {
            $(".cart-page .cart-subtotal-value").html(response.data.subtotal);
          }
          if (response.data.total) {
            $(".cart-page #cart-total").html(response.data.total);
          }

          // Produto da Black Friday derrubou o cupom: some com o cupom e o desconto da tela
          if (response.data.coupon_removed_message) {
            $("#applied-coupon").addClass("hidden");
            $("#coupon-form").removeClass("hidden");
            $(".cart-page .cart-discount-row").remove();
            $("#appliedCouponContainer, #cartDiscountContainer").addClass("hidden");
            showCouponMessage(response.data.coupon_removed_message, "error");
          }

          // Adiciona o novo produto à lista visual do carrinho
          // Usa um seletor específico que encontra a div space-y-4 que contém .cart-item (não .related-product-item)
          if (response.data.cart_item_html) {
            $(".cart-page .space-y-4:has(.cart-item)").append(
              response.data.cart_item_html
            );
          }

          // Remove o produto da lista "Compre também" após 1 segundo
          setTimeout(() => {
            // Guarda referência ao container do box "Compre também" antes de remover o item
            const $relatedBox = $item.closest(".bg-white.rounded-2xl");

            $item.fadeOut(300, function () {
              $(this).remove();

              // Se não houver mais produtos na lista "Compre também", remove o box inteiro
              const remainingItems = $relatedBox.find(
                ".related-product-item"
              ).length;
              if (remainingItems === 0) {
                $relatedBox.fadeOut(300, function () {
                  $(this).remove();
                });
              }
            });
          }, 1000);
        } else {
          $button.prop("disabled", false).text("Adicionar");
          Swal.fire({
            title: "Erro!",
            text:
              response.data?.message || "Erro ao adicionar produto ao carrinho",
            icon: "error",
            confirmButtonColor: "#4f1a46",
            confirmButtonText: "OK",
            customClass: {
              popup: "rounded-2xl",
              confirmButton: "rounded-lg px-6 py-3",
            },
          });
        }
      },
      error: function (xhr, status, error) {
        console.error("Erro ao adicionar produto:", error);
        $button.prop("disabled", false).text("Adicionar");

        Swal.fire({
          title: "Erro!",
          text: "Erro ao adicionar produto. Tente novamente.",
          icon: "error",
          confirmButtonColor: "#4f1a46",
          confirmButtonText: "OK",
          customClass: {
            popup: "rounded-2xl",
            confirmButton: "rounded-lg px-6 py-3",
          },
        });
      },
    });
  });
}
